<template>
  <div>
    <rabbey-table-3
      show-summary
      sum-text="Total por Mes"
      :data="reportData"
      :columns="reportColumns"
      :actions="reportActions"
      :loading="reportDataLoading"
    />
  </div>
</template>

<script>
import { columns } from "@/columns/InternalRequestReportByModules/InternalRequestReportByModuleColumns";

export default {
  name: "InternalRequestByModuleMonthlyReportTable",

  data() {
    return {
      reportData: [],
      reportColumns: columns(this),
      reportActions: [],
      reportDataLoading: false
    };
  },

  mounted() {
    this.GetReportData();
  },

  methods: {
    async GetReportData() {
      this.reportDataLoading = true;
      await this.$http
        .get("/api/InternalServiceRequest/GetInternalRequestReportByModule")
        .then((resp) => {
          this.reportData = resp.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.reportDataLoading = false;
        });
    }
  }
};
</script>

<style scoped></style>
